import { Injectable } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { retry, catchError } from "rxjs/operators";
import { AppComponent } from "./app.component";
import { ErrorService } from "./shared/services/errorService.service";

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(private errorService: ErrorService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            retry(1),
            catchError((error: HttpErrorResponse) => {
                let errorMessage: string;
                switch (error.status) {
                    case 400:
                        errorMessage = "Der er opstået et uventet fejl. Kontakt Softværket for at løse denne fejl.";
                        break;
                    case 401:
                        errorMessage = "Du har ikke adgang. Kontroller dine oplysninger og prøv igen.";
                        break;
                    case 403:
                        errorMessage = "Du har ikke adgang. Kontakt Softværket hvis du mener dette er en fejl.";
                        break;
                    case 404:
                        errorMessage = "Den anvendte handling kunne ikke findes. Kontakt Softværket hvis du mener denne er en fejl.";
                        break;
                    case 405:
                        errorMessage = "Den anvendte handling understøttes ikke. Kontakt Softværket for at løse denne fejl.";
                        break;
                    case 408:
                        errorMessage = "Der er opstået en uventet fejl. Prøv at opdatere din browser eller prøv igen senere";
                        break;
                    case 500:
                        errorMessage = "Der er opstået en uventet systemfejl. Kontakt Softværket for at løse denne fejl.";
                        break;
                    case 501:
                        errorMessage = "Den anvendte handling understøttes ikke. Kontakt Softværket for at løse denne fejl.";
                        break;
                    case 502:
                        errorMessage = "Den anvendte handling understøttes ikke. Kontakt Softværket for at løse denne fejl.";
                        break;
                    case 503:
                        errorMessage = "Den anvendte handling understøttes ikke. Kontakt Softværket for at løse denne fejl.";
                        break;
                    case 505:
                        errorMessage = "Den version af HTTP-protokollen der bruges i anmodningen, understøttes ikke. Kontakt Softværket for at løse denne fejl.";
                        break;
                    default:
                        errorMessage = `Der opstod en uventet fejl ved behandlingen af din anmodning. Modtaget statuskode: ${error.status.toString()} - ${error.statusText.toString()}. Kontakt Softværket for at løse denne fejl.`;
                }
                this.errorService.throwError(errorMessage);
                return throwError(errorMessage);
            })
        );
    }
}
